import {
  AfterViewInit,
  Directive,
  ElementRef,
  Host,
  Inject,
  Input,
  OnDestroy,
  Optional,
  Renderer2,
  SkipSelf
} from '@angular/core';

import {Subscription} from 'rxjs';
import {HeroDictionaryService} from '../../service';

@Directive({
  selector: '[dictionary]',
  standalone: true,
})
export class HeroDictionaryDirective<T = any> implements AfterViewInit, OnDestroy {

  private key: string = '';
  private value: string = '';
  private subscription: Subscription | null = null;

  @Input('dictionary') public tagKey: string | null = null;

  constructor(
    private el: ElementRef,
    private DictionaryService: HeroDictionaryService,
    private renderer: Renderer2
  ) {
  }

  ngAfterViewInit(): void {

    const element = this.el.nativeElement;
    // get element type
    const elementType = element.tagName.toLowerCase();

    let key: string = '';
    switch (elementType) {
      case 'input':
      case 'textarea':
        key = element.placeholder;
        break;
      default:
        key = element.innerHTML;
    }


    // take the tagKey if it is set
    // or the the innerHTML as key
    this.key = this.tagKey || key;
    // add class dictionary
    this.renderer.addClass(this.el.nativeElement, `dictionary`);
    // subscribe to dictionary
    this.subscription = this.DictionaryService.onKey$(this.key).subscribe(({value, found, language}) => {
      // clean css classes so
      // remove all classes that start with 'dictionary-' from the element

      const classList = Array.from(element.classList).map(String); // Convert DOMTokenList to an array
      classList.forEach((className) => {
        if (className.startsWith('dictionary-')) {
          this.renderer.removeClass(element, className);
        }
      });

      this.value = value;
      // add css classes
      if (!found) {
        this.renderer.addClass(element, 'dictionary-not-found'); // add class not-found to
        // set value to the orginal innerHTML
        this.value = key;
      }
      if (language) this.renderer.addClass(element, `dictionary-lang-${language}`); // add lang class to
      // validate or process value


      switch (elementType) {
        case 'input':
        case 'textarea':
          this.renderer.setProperty(element, 'placeholder', this.value);
          break;
        default:
          this.renderer.setProperty(element, 'innerHTML', this.value);
      }
    });

  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

}
